module.exports = __webpack_public_path__ + "static/media/webscape_2023.438f4588.jpeg";